import type { ViewName, ViewSizeMm } from "../types";
import { TOP_BOX, BOTTOM_BOX, HORIZONTAL_PADDING_PX, PLANNER_SAFE_PADDING_PX, VERTICAL_PADDING_PX } from "../constant";

export const computeViewSizesInMillimeters = (
    roomLengthMm: number,
    roomDepthMm: number,
    roomHeightMm: number
): ViewSizeMm => ({
    top: { w: roomLengthMm, h: roomDepthMm },
    front: { w: roomLengthMm, h: roomHeightMm },
    back: { w: roomLengthMm, h: roomHeightMm },
    left: { w: roomDepthMm, h: roomHeightMm },
    right: { w: roomDepthMm, h: roomHeightMm },
});

export const getViewsToRender = (sections: any[], includeEmpty?: boolean): ViewName[] => {
    const presentSides = new Set<string>(sections.map((section) => section.side));
    const allViews: ViewName[] = ["top", "front", "back", "left", "right"] as ViewName[];
    if (includeEmpty) return allViews;
    const result: ViewName[] = ["top"] as ViewName[];
    if (presentSides.has("front")) result.push("front");
    if (presentSides.has("back")) result.push("back");
    if (presentSides.has("left")) result.push("left");
    if (presentSides.has("right")) result.push("right");
    return result;
};

export const estimateViewSizeInPixels = (name: ViewName, sizesMm: ViewSizeMm, scale: number) => {
    const widthPx = sizesMm[name].w * scale + 2 * HORIZONTAL_PADDING_PX + PLANNER_SAFE_PADDING_PX;
    const heightPx = sizesMm[name].h * scale + 2 * VERTICAL_PADDING_PX + PLANNER_SAFE_PADDING_PX;
    return { wPx: widthPx, hPx: heightPx };
};

export const maxScaleForArea = (widthMm: number, heightMm: number, areaWidthPx: number, areaHeightPx: number) => {
    const scaleByWidth = (areaWidthPx - 2 * HORIZONTAL_PADDING_PX - PLANNER_SAFE_PADDING_PX) / Math.max(widthMm, 1e-6);
    const scaleByHeight = (areaHeightPx - 2 * VERTICAL_PADDING_PX - PLANNER_SAFE_PADDING_PX) / Math.max(heightMm, 1e-6);
    return Math.max(0, Math.min(scaleByWidth, scaleByHeight));
};
